import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const Accordion = styled.div`
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  width: 40%;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;

  &.expanded {
    height: 165px;
    background: ${theme.wild.color.nova.base.solid[20]};

    button {
      cursor: default;
    }

    button svg {
      display: none;
    }
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }

  button {
    padding: 24px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .accordion-body {
    margin-top: auto;
    padding: 0 56px 24px 24px;
  }
`

export const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  background: ${theme.wild.color.nova.base.black};
  padding-bottom: 32px;
  border-radius: 4px;

  @media (min-width: 768px) {
    padding-bottom: 40px;
  }

  @media (min-width: 1024px) {
    border-radius: 0 4px 4px 0;
    padding-bottom: 32px;
  }
`

export const BottomSliderWrapper = styled.div`
  width: 100%;
  max-width: 740px;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;
  margin-top: -150px;

  @media (min-width: 768px) {
    padding: 0 40px;
  }

  @media (min-width: 1024px) {
    padding: 0 64px;
  }
`

export const AnimationArea = styled.div`
  flex: 1;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    margin-bottom: 40px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 45px;
  }
`

export const SliderControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;

  position: relative;
  z-index: 9;

  button {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: ${theme.wild.color.nova.brand.accent[80]};
    svg {
      width: 16px;
      height: 16px;
    }

    svg path {
      fill: ${theme.wild.color.nova.base.black};
    }

    &.disabled {
      pointer-events: none;
      background: ${theme.wild.color.nova.transparency.white[10]};

      svg path {
        opacity: 0.4;
        fill: ${theme.wild.color.nova.base.white};
      }
    }
  }

  @media (min-width: 1024px) {
    display: none;
  }
`

export const SlideWrapper = styled(Box)`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding-top: 32px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding-top: 40px;
  }
`

export const SlideTrack = styled(Box)`
  position: relative;
  z-index: 2;
  margin-top: auto;

  .slick-list {
    position: relative;
    z-index: 3;
  }

  .slick-track {
    display: flex !important;
    position: relative;
    padding-bottom: 150px;
  }
`

export const CauseText = styled(Box)`
  text-align: center;
`

export const Divider = styled.div`
  pointer-events: none;
  position: absolute;
  top: 32px;
  bottom: 0;
  width: 2px;
  margin-left: -1px;
  left: 50%;
  background: repeating-linear-gradient(
      to bottom,
      transparent 0 7px,
      rgba(255, 255, 255, 0.2) 7px 9px
    )
    80%/1px 100% no-repeat;
  z-index: 1;

  bottom: 150px;
`

export const Dots = styled.div`
  position: absolute;
  bottom: 150px;
  left: 50%;
  z-index: 5;

  transform: translate(-50%, -2px);

  @media (min-width: 768px) {
    transform: translate(-50%, 1px);
  }
`

export const Dot = styled(Box)`
  position: absolute;
  border-radius: 50%;
  background: ${theme.wild.color.nova.brand.accent[80]};
  bottom: 0;
  transform: translateX(-50%);

  width: 6px;
  height: 6px;

  @media (min-width: 768px) {
    width: 8px;
    height: 8px;
  }
`

export const Slide = styled(Box)`
  position: relative;
  z-index: 3;
`
